import { render, staticRenderFns } from "./TableCols.vue?vue&type=template&id=35d5dc51&scoped=true"
import script from "./TableCols.vue?vue&type=script&lang=js"
export * from "./TableCols.vue?vue&type=script&lang=js"
import style0 from "./TableCols.vue?vue&type=style&index=0&id=35d5dc51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d5dc51",
  null
  
)

export default component.exports